import React from 'react';
import Icon from '@/components/ui/AppIcon';

const orders = [
  {
    id: 'order-1042',
    date: '17 Tem 2026, 09:14',
    store: 'Taksim',
    items: ['Caramel Latte Grande', 'Tereyağlı Kruvasan'],
    total: 134,
    stars: 13,
    status: 'teslim',
  },
  {
    id: 'order-1038',
    date: '14 Tem 2026, 08:45',
    store: 'Nişantaşı',
    items: ['Hazelnut Latte Grande', 'Cheesecake Dilimi'],
    total: 150,
    stars: 15,
    status: 'teslim',
  },
  {
    id: 'order-1031',
    date: '11 Tem 2026, 10:22',
    store: 'Beşiktaş',
    items: ['Cold Brew Venti'],
    total: 95,
    stars: 9,
    status: 'teslim',
  },
  {
    id: 'order-1025',
    date: '08 Tem 2026, 15:05',
    store: 'Kadıköy',
    items: ['Caramel Chiller Grande', 'Çikolatalı Muffin'],
    total: 154,
    stars: 15,
    status: 'teslim',
  },
  {
    id: 'order-1019',
    date: '05 Tem 2026, 07:58',
    store: 'Taksim',
    items: ['Sezonluk Baharatlı Latte Tall'],
    total: 95,
    stars: 9,
    status: 'teslim',
  },
];

export default function OrderHistory() {
  return (
    <div>
      <h2 className="text-foreground font-bold text-base mb-3">Sipariş Geçmişi</h2>
      <div className="space-y-3">
        {orders?.map((order) => (
          <div key={order?.id} className="bg-card rounded-2xl p-4 card-shadow">
            <div className="flex items-start justify-between mb-2">
              <div>
                <p className="text-foreground font-bold text-sm">#{order?.id?.replace('order-', '')}</p>
                <p className="text-muted-foreground text-xs">{order?.date} · {order?.store}</p>
              </div>
              <span className="bg-green-100 text-green-700 text-[10px] font-bold px-2 py-0.5 rounded-full">
                Teslim Edildi
              </span>
            </div>
            <div className="space-y-1 mb-3">
              {order?.items?.map((item) => (
                <div key={`item-${order?.id}-${item}`} className="flex items-center gap-2">
                  <span className="w-1 h-1 rounded-full bg-muted-foreground flex-shrink-0" />
                  <p className="text-muted-foreground text-xs">{item}</p>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between pt-2 border-t border-border">
              <div className="flex items-center gap-1">
                <Icon name="StarIcon" size={12} variant="solid" className="text-gold" />
                <span className="text-gold font-bold text-xs">+{order?.stars} Yıldız</span>
              </div>
              <span className="text-foreground font-bold text-sm">₺{order?.total}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}